import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@material-ui/core';
import GridContainer from '../../../components/GridContainer';
import TextfieldWrapper from '../../../components/FormikWrappers/TextfieldWrapper';
import CheckBoxWrapper from '../../../components/FormikWrappers/CheckboxWrapper';
import { addSafetyProject, editSafetyProject } from '../../../redux/actions/safety';
import { useDispatch } from 'react-redux';
import '../../Users/NewUser/newuser.scss';

const NewSafetyProject = ({ open, handleClose, handleOk, project }) => {
  const formRef = useRef();
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('This is Required Field'),
    description: Yup.string()
  });

  const [initialFormState, setInitialFormState] = useState({
    name: '',
    description: '',
    isActive: true
  });

  useEffect(() => {
    if (project?.id) {
      setInitialFormState({
        name: project.name,
        description: project.description || '',
        isActive: project.isActive
      });
    }
  }, [project]);

  const submitForm = (values) => {
    if (project?.id) {
      dispatch(editSafetyProject(project.id, values, handleOk));
    } else {
      dispatch(addSafetyProject(values, handleOk));
    }
  };

  return (
    <Dialog maxWidth="md" fullWidth onClose={handleClose} open={open}>
      <DialogTitle>{project ? 'Update Safety Project' : 'New Safety Project'}</DialogTitle>
      <DialogContent dividers>
        <Formik
          innerRef={formRef}
          initialValues={{ ...initialFormState }}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={submitForm}
        >
          {() => (
            <Form>
              <GridContainer className="newuser__container">
                <Grid item xs={12}>
                  <TextfieldWrapper name="name" label="Project Name" placeholder="Project Name" />
                </Grid>
                <Grid item xs={12}>
                  <TextfieldWrapper name="description" label="Description" placeholder="Description" />
                </Grid>
                {project?.id && (
                  <Grid item xs={12}>
                    <CheckBoxWrapper name="isActive" label="Active" />
                  </Grid>
                )}
              </GridContainer>
            </Form>
          )}
        </Formik>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => formRef.current.submitForm()} color="primary">
          Save
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

NewSafetyProject.propTypes = {
  project: PropTypes.object,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleOk: PropTypes.func
};

export default NewSafetyProject;
